import Vuex, { Module, Payload } from 'vuex';
import { RootStoreState } from '@/store';
import { MsspModalObject, TenantModalObject, ProductModalObject, AnotherProductObjectModalType, MsspPrefilterList } from './types';
import Vue from 'vue';
Vue.use(Vuex);
export interface TenantManagementStoreState {
  msspSelectedName: string;
  newMsspModalObject: MsspModalObject;
  newTenantModalObject: TenantModalObject;
  newProductModalObject: ProductModalObject;
  productAnotherModalObject: AnotherProductObjectModalType;
  prefilterObject: MsspPrefilterList;
  customisedColumns: any;
  widths: any;
  productCreated: boolean;
  capFName: any;
  tzProvision: boolean;
  registered:boolean;
  tenants: string;
}
export interface SetNewProductModalObjectPayload extends Partial<Payload> {
  newProductModalObject: {
    MSSPname: string,
    MsspId: string,
    tenantName: string,
    tenantId: string,
    accessScopeMessage: string,
    authCode: string,
    serialNumber: string,
    friendlyName: string,
    performFurtherValidation: boolean,
    isdefaultgroupAssignedtoTenant: boolean,
    productDetails: [{
      productName: string,
      productId: string,
      serviceName: string,
      serviceId: string,
      unitSelected: string,
      expiryType: string,
      regionSelected: string,
      platform: string,
      showHA: string,
    }],
  };
}
export interface SetAnotherProductModalObjectPayload extends Partial<Payload> {
  productAnotherModalObject: {
    productName: string,
    serviceName: string,
    unitSelected: string,
    upperLimit: string,
    dateSelected: string,
    expiryType: string,
    regionSelected: string,
    subDomain: string,
    platformName: string,
    productId: string,
    applicationName: string,
    showFriendlyName: string,
    friendlyNameBaseText: string,
    showUnits: boolean,
    showSubDomainName: boolean,
    showPlatFormOptions: boolean,
    showApplicationOption: boolean,
    friendlyName: string,
    regionName: string,
    showRegion: boolean,
    showHA: boolean,
    isServiceTypechangeAllowed: boolean,
  };
}

export default {
  namespaced: true,
  state: {
    msspSelectedName: '',
    newMsspModalObject: {
      MSSPname: '',
      emailAddress: '',
      contactName: '',
      companyName: '',
      phoneNumber: '',
      streetAddress: '',
      city: '',
      country: '',
      state: '',
      zipCode: '',
      isDefaultGroup: 'YES',
      MSSPID: '',
      additionalComments: '',
      province: '',
      partyGroupId: '',
      firstName: '',
      lastName: '',
      msspNumber: '',
      msspContractid: '',
    },
    newTenantModalObject: {
      MSSPname: '',
      tenantName: '',
      contactName: '',
      companyName: '',
      emailAddress: '',
      phoneNumber: '',
      streetAddress: '',
      cityName: '',
      countryName: '',
      stateName: '',
      zipCode: '',
      province: '',
      additionalMessage: '',
      productGroupId: '',
      tenantNumber: '',
      tenantContractId: '',
    },
    newProductModalObject: {
      MSSPname: '',
      MsspId: '',
      tenantName: '',
      tenantId: '',
      accessScopeMessage: '',
      authCode: '',
      serialNumber: '',
      friendlyName: '',
      performFurtherValidation: false,
      isdefaultgroupAssignedtoTenant: false,
      productDetails: [{
        productName: 'Product 1',
        productId: '',
        serviceName: '',
        serviceId: '',
        unitSelected: 'noUpperLimit',
        expiryType: 'Never',
        regionSelected: '',
        platform: '',
        showHA: '',
      }],
    },
    productAnotherModalObject: {
      productName: '',
      serviceName: '',
      unitSelected: 'noUpperLimit',
      upperLimit: '',
      dateSelected: '',
      expiryType: 'Never',
      regionSelected: '',
      subDomain: '',
      OganizationIDValue: '',
      platformName: '',
      productId: '',
      applicationName: '',
      showFriendlyName: 'NO',
      friendlyNameBaseText: '',
      showUnits: false,
      showSubDomainName: false,
      showOrganizationId: false,
      showPlatFormOptions: false,
      showApplicationOption: false,
      friendlyName: '',
      regionName: '',
      showRegion: false,
      showHA: false,
      isServiceTypechangeAllowed: false,
    },
    prefilterObject: {
      MSSPName: '',
      MSSPID:   0,
      Tenants: [],
      MSSPStatus: '',
    },
    widths: {
      msspp: '',
      tenant: '',
      serNo: '',
      friendlyName: '',
      firmware: '',
      product: '',
      service: '',
      units: '',
      status: '',
      startdate: '',
      expirydate: '',
      action: '',
    },
    customisedColumns: {},
    productCreated: false,
    capFName: '',
    tzProvision: false,
    registered: false,
    tenants: '',
  },
  mutations: {
    editWidth(state: any, payload) {
      state.widths[payload.propertyName] = payload.width;
    },
    setSelectedMsspName(state, payload) {
      // @ts-ignore
      state.msspSelectedName = payload.MSSPname;
    },
    setNewMsspModalObject(state, payload) {
      // @ts-ignore
      state.newMsspModalObject = payload.newMsspModalObject;
    },
    setNewTenantModalObject(state, payload) {
      // @ts-ignore
      state.newTenantModalObject = payload.newTenantModalObject;
    },
    setNewProductModalObject(state, payload) {
      // @ts-ignore
      state.newProductModalObject = payload.newProductModalObject;
    },
    setNewProductObjectMsspName(state, payload) {
      state.newProductModalObject.MSSPname = payload.MSSPname;
    },
    setNewProductObjectMsspId(state, payload) {
      console.warn('payload', payload.MsspId);
      state.newProductModalObject.MsspId = payload.MsspId;
    },
    setNewProductObjectTenantName(state, payload) {
      state.newProductModalObject.tenantName = payload.tenantName;
    },
    setNewProductObjectAuthCode(state, payload) {
      state.newProductModalObject.authCode = payload.authCode;
    },
    setNewProductObjectSerialNumber(state, payload) {
      state.newProductModalObject.serialNumber = payload.serialNumber;
    },
    setNewProductObjectFriendlyName(state, payload) {
      state.newProductModalObject.friendlyName = payload.friendlyName;
    },
    setNewProductObjectTenantId(state, payload) {
      state.newProductModalObject.tenantId = payload.tenantId;
    },
    setNewProductObjectdefaultGrpFlag(state, payload) {
      state.newProductModalObject.isdefaultgroupAssignedtoTenant = payload.isdefaultgroupAssignedtoTenant;
    },
    setNewProductObjectFurtherValidation(state, payload) {
      state.newProductModalObject.performFurtherValidation = payload.performFurtherValidation;
    },
    setNewProductObjectProductDetail(state, payload) {
      state.newProductModalObject.productDetails = payload.productDetails.slice();
    },
    setNewProductAccessScope(state, payload) {
      state.newProductModalObject.accessScopeMessage = payload.accessScopeMessage;
    },
    setAnotherProductModalObject(state, payload) {
      state.productAnotherModalObject = payload.productAnotherModalObject;
    },
    setPrefilterObject(state, payload) {
      state.prefilterObject = payload.prefilterObject;
    },
    setCustomisedColumns(state, payload) {
      // console.warn('steak', payload.customisedColumns);
      state.customisedColumns = payload.customisedColumns;
    },
    setProductCreated(state, payload) {
      state.productCreated = payload.productCreated;
    },
    setcapFName(state, payload) {
      state.capFName = payload.capFName;
    },
    setTzProvision(state, payload) {
      state.tzProvision = payload.tzProvision;
    },
    setRegistered(state, payload) {
      state.registered = payload.registered;
    },
    setTenant(state, payload) {
      state.tenants = payload.tenants;
      console.warn('payloadTe', payload.tenants, state);
    },
  },
  actions: {
  },
  getters: {
    getSelectedMsspDetails: state => state.msspSelectedName,
    getWidths: state => state.widths,
    getNewMsspModalObject(state) {
      return state.newMsspModalObject;
    },
    getNewTenantModalObject(state) {
      return state.newTenantModalObject;
    },
    getNewProductModalObject(state) {
      return state.newProductModalObject;
    },
    getAnotherProductModalObject(state) {
      return state.productAnotherModalObject;
    },
    getProductModalFurtherValidation(state) {
      return state.newProductModalObject.performFurtherValidation;
    },
    getPreFilter(state) {
      return state.prefilterObject;
    },
    getCustomisedColumns(state): any {
      return state.customisedColumns;
    },
    getProductCreated(state): any {
      return state.productCreated;
    },
    getCapFName(state): any {
      return state.capFName;
    },
    getTzProvision(state): any {
      return state.tzProvision;
    },
    getRegistered(state): any {
      return state.registered;
    },
    getTenant(state): any {
      console.warn('get', state);
      return state.tenants;
    },
  },
} as Module<TenantManagementStoreState, RootStoreState>;
